import type { JSX } from 'react';

import { Translate, useI18n } from '@change-corgi/core/react/i18n';
import { FakeLink } from '@change-corgi/design-system-legacy/components/actions';
import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';

import { CopyLinkButton } from './components/CopyLinkButton';
import { useShareUrl } from './hooks/useShareUrl';

export function ShareUrl(): JSX.Element {
	const { data, actions } = useShareUrl();
	const { translate } = useI18n();

	return (
		<div className="flex w-full flex-wrap gap-4 lg:flex-nowrap">
			<Flex
				id="share-your-petition-link"
				px={16}
				py={8}
				sx={{
					alignItems: 'center',
					backgroundColor: 'primary-greyBackground',
					borderRadius: 'standard',
					border: '1px solid',
					borderColor: 'neutral-grey100',
					flex: 1,
					minWidth: 100,
					flexShrink: 1,
				}}
			>
				<Text
					aria-label={translate('corgi.petition.starter_dashboard.grow_petition.copy_link.short_url_aria_label')}
					data-testid="copylink-input"
					mr="8px"
					ellipsis
					size="small"
					sx={{ maxWidth: 500, flexShrink: 1 }}
				>
					{data.shareUrl}
				</Text>
				{data.canEditUrl && (
					<FakeLink
						variant="primary"
						onClick={actions.onEditUrl}
						data-testid="customUrl-edit-url-link"
						data-qa="customUrl-edit-url-link"
						ml="auto"
						sx={{ flexShrink: 0, fontSize: '14px' }}
					>
						<Translate value="corgi.petition.starter_dashboard.grow_petition.copy_link.edit_link" />
					</FakeLink>
				)}
			</Flex>
			<CopyLinkButton shareUrl={data.shareUrl} />
		</div>
	);
}
